import React from 'react';
import { FreeFocusInside } from 'react-focus-lock';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const ClassSwitchingInfoModal = (props) => {
  const { onHandleShowClassSwitchingInfoModal } = props;
  return (
    <FreeFocusInside>
      <ConfirmDialog
        wrapperClassName="!min-w-fit"
        size="tiny"
        title="Unsaved Updates"
        onSuccess={onHandleShowClassSwitchingInfoModal}
        onClose={onHandleShowClassSwitchingInfoModal}
        content={{
          btnPrimary: 'OK',
        }}
      >
        <p className="section-switching-text">
          Changes to the list of students for this assignment will only be saved
          if you update settings for this class or apply changes to all classes
          assigned.
        </p>
      </ConfirmDialog>
    </FreeFocusInside>
  );
};

export default ClassSwitchingInfoModal;
